import { render, staticRenderFns } from "./TabChild.vue?vue&type=template&id=74bba884&"
import script from "./TabChild.vue?vue&type=script&lang=js&"
export * from "./TabChild.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports